import { Component, Input, OnInit } from '@angular/core';
import {RoutingPath} from "../../../configs/routing-path";
import { ResponseFromRequest } from './responseFromRequest';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Responses } from './responses';

@Component({
  selector: 'app-response',
  templateUrl: './response.component.html',
  styleUrls: ['./response.component.scss']
})
export class ResponseComponent implements OnInit {

  @Input() response: ResponseFromRequest;
  prePage: string;

  public home;
  public code: string;
  public radicado = '';
  public message: string;
  public indexCode: number;
  public urlBack: string;
  public urlNext: string;
  public textBack: string;
  public textNext: string;


  constructor(private _ROUTE: ActivatedRoute,private router: Router) { }

  ngOnInit() {
    this.radicado = this._ROUTE.snapshot.paramMap.get('radicado');
    this.code = this._ROUTE.snapshot.paramMap.get('code');

    this.message = this._ROUTE.snapshot.paramMap.get('message');

    this.home = RoutingPath.appRouting.components.dashboard.path;
    
    if (this.code!=undefined){
      this.indexCode = Responses.Message.findIndex(a=>a.code===this.code);
      if(!this.message){
        this.message = Responses.Message[this.indexCode].message;
      }
      this.urlBack = Responses.Message[this.indexCode].urlBack;
      this.urlNext = '/' + Responses.Message[this.indexCode].urlNext;
      this.textBack = Responses.Message[this.indexCode].textBack;
      this.textNext = Responses.Message[this.indexCode].textNext;
    }

  }

  next(){
    this.router.navigate(['/' + RoutingPath.appRouting.components.individual_retreat.path + '/'
      + RoutingPath.appRouting.components.individual_retreat.pages.home.path]);
  }

  back(){
    this.router.navigate(['/' + RoutingPath.appRouting.components.dashboard.path
      + '/' + RoutingPath.appRouting.components.dashboard.pages.home.path]);
  }

}
